import { TBookingContextDef } from '@providers/booking/types'

export const hasGroomingServiceType = (bookingCtx: TBookingContextDef) =>
  (bookingCtx.state.data.serviceTypes?.findIndex((st) => st.serviceType?.name === 'grooming') ?? -1) >= 0
